/**
 *
 * Accordion
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Accordion as SemanticUIAccordion } from '@cashfree-intl/coherent';

function Accordion({
  className = 'accordion-wrapper',
  list,
  activeIndex,
  handleClick,
  dataEventName = '',
}) {
  return (
    <div className={className}>
      {list.map((obj, index) => {
        const { id, title, content } = obj;

        return (
          <SemanticUIAccordion
            key={id}
            className={activeIndex === index ? '' : 'in-active'}
          >
            <SemanticUIAccordion.Title
              data-testid="title"
              active={activeIndex === index}
              index={index}
              onClick={handleClick}
              data-event-name={
                dataEventName
                  ? `${dataEventName} ${index}`
                  : 'Dropdown_Account_Manager'
              }
              data-ignore-inner-text="true"
            >
              {typeof title === 'function'
                ? title({ index, activeIndex })
                : title}
            </SemanticUIAccordion.Title>
            <SemanticUIAccordion.Content
              data-testid="content"
              active={activeIndex === index}
            >
              {typeof content === 'function' ? content() : content}
            </SemanticUIAccordion.Content>
          </SemanticUIAccordion>
        );
      })}
    </div>
  );
}

Accordion.propTypes = {
  className: PropTypes.string,
  list: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
  handleClick: PropTypes.func,
  dataEventName: PropTypes.string,
};

export default memo(Accordion);
